/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {ChecksEntrypoint} from './Checks'
import {CommitsEntrypoint, CommitsWithRangeEntrypoint} from './Commits'
import {ConversationsEntrypoint} from './Conversations'
import type {PullRequestsRouteComponents} from './create-pull-requests-routes'
import {ChangesEntrypoint, ChangesWithRangeEntrypoint, FilesEntrypoint, FilesWithRangeEntrypoint} from './FilesChanged'
import {FindingsEntrypoint} from './FindingsRoute'
import {LayoutEntrypoint} from './Layout'
import {OverviewIndexRouteEntrypoint, OverviewRouteEntrypoint} from './Overview'
import {RepoPullsDashboardContent} from './RepoPullsDashboardContent'
import {RepoPullsDashboardLayout} from './RepoPullsDashboardLayout'

export {
  ChangesEntrypoint,
  ChangesWithRangeEntrypoint,
  ChecksEntrypoint,
  CommitsEntrypoint,
  CommitsWithRangeEntrypoint,
  ConversationsEntrypoint,
  FilesEntrypoint,
  FilesWithRangeEntrypoint,
  FindingsEntrypoint,
  LayoutEntrypoint,
  OverviewIndexRouteEntrypoint,
  OverviewRouteEntrypoint,
  PullRequestErrorState,
  RepoPullsDashboardContent,
  RepoPullsDashboardLayout,
}

export const pullRequestsRouteComponents = {
  PullRequestErrorState,
  LayoutEntrypoint,
  CommitsEntrypoint,
  CommitsWithRangeEntrypoint,
  ChangesEntrypoint,
  ChangesWithRangeEntrypoint,
  FilesEntrypoint,
  FilesWithRangeEntrypoint,
  ConversationsEntrypoint,
  ChecksEntrypoint,
  OverviewIndexRouteEntrypoint,
  OverviewRouteEntrypoint,
  FindingsEntrypoint,
  RepoPullsDashboardContent,
  RepoPullsDashboardLayout,
} satisfies PullRequestsRouteComponents
